export var baseVirtualCardDetailsTheme = {
  baseStyle: _ref => {
    var {
      enableCopy
    } = _ref;
    return {
      label: {
        display: 'inline-flex',
        width: 'max-content',
        textStyle: 'body4Semi'
      },
      mainLabel: {
        width: 'max-content',
        display: 'inline-flex',
        alignItems: 'center',
        textStyle: 'body2',
        cursor: enableCopy ? 'pointer' : 'default',
        gap: 'xxs'
      },
      copyButton: {
        display: 'inline-flex',
        alignItems: 'center',
        opacity: 0,
        visibility: 'hidden',
        transition: 'opacity 0.2s ease-in-out',
        _hover: {
          visibility: 'visible',
          opacity: 1
        }
      }
    };
  },
  variants: {
    default: {
      label: {
        color: 'neutral.darker'
      },
      mainLabel: {
        color: 'neutral.black'
      },
      copyButton: {
        color: 'neutral.black'
      }
    },
    inverted: {
      label: {
        color: 'neutral.lighter'
      },
      mainLabel: {
        color: 'neutral.white'
      },
      copyButton: {
        color: 'neutral.white'
      }
    }
  },
  defaultProps: {
    variant: 'default'
  }
};
//# sourceMappingURL=BaseVirtualCardDetails.theme.js.map